import { defineMessages } from 'react-intl';
export default defineMessages({
  loadMoreBtnLabel: {
    id: "CourseDetailsContent.loadMoreBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Load more"
    }]
  },
  courseAuthorsTitle: {
    id: "CourseDetailsContent.courseAuthorsTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Course authors"
    }]
  },
  completedItemsInSection: {
    id: "CourseDetailsContent.completedItemsInSection",
    defaultMessage: [{
      "type": 0,
      "value": "Completed "
    }, {
      "type": 1,
      "value": "completedLessons"
    }, {
      "type": 0,
      "value": " lesson(s) and "
    }, {
      "type": 1,
      "value": "completedQuizzes"
    }, {
      "type": 0,
      "value": " quiz(zes) of "
    }, {
      "type": 1,
      "value": "totalLessons"
    }, {
      "type": 0,
      "value": " total lesson(s) and "
    }, {
      "type": 1,
      "value": "totalQuizzes"
    }, {
      "type": 0,
      "value": " total quiz(zes) in the section"
    }]
  },
  relatedCoursesLabel: {
    id: "CourseDetailsContent.relatedCoursesLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Related courses"
    }]
  }
});